import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EllipsisPlaceholder } from '../src/EllipsisPlaceholder.tsx';
import type { LivePagesEllipsisDropdownComponentProps } from '../src/types.ts';

export const LivePagesEllipsisDropdownComponent: LoadableType<LivePagesEllipsisDropdownComponentProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LivePagesEllipsisDropdown" */ '../src/LivePagesEllipsisDropdown.tsx'
				)
			).LivePagesEllipsisDropdownComponent,
		loading: EllipsisPlaceholder,
	});
